import { createSlice, createAsyncThunk, createEntityAdapter, PayloadAction } from '@reduxjs/toolkit';
import axios from '../utils/axios'

const initialState = {
    data: null,
    status: 'idle',
    projects: []
};

// export const getMe = createAsyncThunk('/users/get', async () => {

//    return {
//     name: 'Azimjon Bekmuradov',
//     id: 121,
//     about: 'Toshkent Moliya Instituti, 3-kurs, IBI-80 guruxi talabasi',
//     phone: 998909541262,
//     email: 'azimjon.nodir@gmail.com',
//     created_at: new Date()
//    }
// })


export const UserRegister = createAsyncThunk('/me/register', async ({user, setError}) => {
  let res = axios.post('users', user).catch((err)=>{
    if(err.response.data.message == "The customer with this email has been created before!"){
      setError('Bu emailda akkount mavjud')
    }
    else{
      setError(err.response.data.message)
    }
  console.log(err)
})

 const data = await res

 if(data.data.success) {
  setError('')
  localStorage.setItem('token' , data.data.data.token)
  return  data.data.data.user
 }

})

export const UserLogin = createAsyncThunk('/me/login', async ({user, setError}) => {
  let res = axios.post('users/login', user).catch((err)=>{
  console.log(err)
  setError(err.response.data.message)
})

 const data = await res

 if(data.data.success) {
  setError('')
  console.log(data);
  localStorage.setItem('token' , data.data.data.token)
  return  data.data.data.user
 }

})

export const ForgetPassword = createAsyncThunk('/forget', async (obj) => {
  console.log(obj, 'obj')
  await axios.post('users/forget', obj).then((res)=>{
    return res.data
  }).catch((err)=>{
  console.log(err)
  setError(err.response.data.message)
})
})

export const Update = createAsyncThunk('/update', async (obj) => {
  console.log(obj, 'obj')
  await axios.post('users/enter', obj).then((res)=>{
    return res.data
  }).catch((err)=>{
  console.log(err)
  setError(err.response.data.message)
})
})


export const getMe = createAsyncThunk('/me/get', async () => {
  let res = axios.get('users/me', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  }).catch((err)=>{
  console.log(err)
  return null
  
})

 const data = await res

   return data.data.data.user


})

export const createProject =  createAsyncThunk('/me/createProject', async (item) => {
  let res = axios.post('projects', item, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  }).catch((err)=>{
  console.log(err)
  
})

 const data = await res
  console.log(data, 'projects');
  if(data.data.success){
    alert('Loyiha yaratildi')
    // return 
  }
// data.data.data.Projects

})

export const createDoc =  createAsyncThunk('/me/createDoc', async (item) => {
  let res = axios.post('docs', item, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  }).catch((err)=>{
  console.log(err)
  
})

 const data = await res
  console.log(data, 'projects');
  if(data.data.success){
    alert('Prezentatsiya yaratildi')
    // return 
  }
// data.data.data.Projects

})



export const getOwnProjects =  createAsyncThunk('/me/getOwnProjects', async () => {
  let res = axios.get('projects/own', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  }).catch((err)=>{
  console.log(err)
  
})

 const data = await res
  console.log(data, 'projects');
 return data.data.data.Projects

})

export const editUser = createAsyncThunk('/users/edit', async (item) => {

	let res = axios.put(`users/${item._id}`, item,{
	  headers: {
		Authorization: `Bearer ${localStorage.getItem('token')}`
	  }
	}).catch((err)=>{
	  console.log(err)
	  // setError(err.response.data.message)
	})
	
	 const data = await res
	 console.log(data);
	 if(data.data.success) {
	  alert("Foydalanuvchi o'zgartirildi")
	 }
	//  return data.data.data.user
	
	 
  })

const me = createSlice({
    name: 'users',
    initialState,
    reducers: {},
    extraReducers(builder) {
      builder
      // .addCase(getMe.pending, (state, action) => {
      //   state.status = 'loading'
      // })
      // .addCase(getMe.rejected, (state, action) => {
      //   state.status = 'failed'
      // })
      // .addCase(getMe.fulfilled,(state, action) => {
      //   // state.status = "idle";
      //   state.data = action.payload;
      //   state.status = 'succeeded'
      // })
      .addCase(UserRegister.fulfilled,(state, action) => {
        // state.status = "idle";
        if(action.payload) {
          state.data = action.payload;
          state.status = 'succeeded'
          window.location.pathname = '/'
        }
      })
      .addCase(UserLogin.fulfilled,(state, action) => {
        // state.status = "idle";
        if(action.payload) {
          state.data = action.payload;
          state.status = 'succeeded'
          window.location.pathname = '/'
        }
      })
      .addCase(getMe.fulfilled,(state, action) => {
        // state.status = "idle";
        if(action.payload) {
          state.data = action.payload;
          state.status = 'succeeded'
        }
      })
      .addCase(getMe.rejected,(state, action) => {
        // state.status = "idle";
        
          
          state.status = 'failed'
        
      })
      
      .addCase(getOwnProjects.fulfilled,(state, action) => {
        // state.status = "idle";
        
          state.projects = action.payload;
          state.status = 'succeeded'
        
      })
      .addCase(createProject.fulfilled,(state, action) => {
        // state.status = "idle";
        
          
          state.status = 'idle'
        
      })
	  .addCase(editUser.fulfilled,(state, action) => {
        // state.status = "idle";
        
          
          state.status = 'idle'
        
      })
      .addCase(createDoc.fulfilled,(state, action) => {
        // state.status = "idle";
        
          
          state.status = 'idle'
        
      })
      }
  });
export const reducer = me.reducer;